import React, { Component } from "react";
import PageHelmet from "../../component/common/Helmet";
import Breadcrumb from "../../elements/common/Breadcrumb";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer";
import Counter from "../../elements/counters/Counter";


class About extends Component{
    render(){
        let title = 'About Expert Alumni';
        return(
            <React.Fragment>
                <PageHelmet pageTitle='About Expert Alumni' />

                <Header headerPosition="header--static logoresize" logo="all-dark" color="color-black"/>
                {/* Start Breadcrump Area */}
                <Breadcrumb title={'About'}   />
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/about/about-3.jpg" alt="Expert Alumni"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title">{title}</h2>
                                            <p className="description">Expert Alumni is a vibrant community welcoming all of our 40,000+ alumni members from
more than 11 countries worldwide. EEVS has the reputation of being one of the best education
providers, which helps students in selection of right course to pursue the career of their dreams.</p>
                                            <p className="description">Being a member you can get access to amazing offers and special discount from our partners, as
it is exclusive to our alumni members you should definitely become one if you haven’t already.</p>
                                            <p className="description">To thank you for the loyalty for being our alumni member we work hard to give you service that
you’ll find highly beneficial. We are diligent to give you the service you deserve and help keep
you updated on news relevant to the industry.</p>
                                        </div>
                                        <div className="row mt--30">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h3 className="title">Who we are</h3>
                                                    <p>Expert Alumni are clients who have used our services in past.</p>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h3 className="title">Who we are</h3>
                                                    <p>Our Alumni are a worldwide community from more than 11 countries.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End About Area  */}

                    {/* Start Counterup Area */}
                <div className="counterup-area pb--80 pt--40 theme-text-white" style={{backgroundColor: '#0054a6'}}>
                    <div className="container">
                        <Counter />
                    </div>
                </div>
                {/* End Counterup Area */}

                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area pb--80 pt--80  rn-finding-us bg_color--1">
                    <div className="inner ">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">Don't have membership yet?</h4>
                                <p>Are you an existing EEVS client but don't have alumni membership yet? You can join now and start getting the benefits as soon as your application is approved.</p>
                                <a className="rn-btn btn-white" href="/join-now">JOIN NOW</a>
                            </div>
                        </div>
                        <div className="thumbnail">
                            <div className="image">
                                <img src="/assets/images/about/finding-us-01.jpg" alt="EEVS Alumni"/>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Finding Us Area  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />

            </React.Fragment>
        )
    }
}
export default About